module.exports = __webpack_public_path__ + "img/pr-5.2c99a945.png";